<template>
  <div>
    <el-button slot="btn" icon="el-icon-refresh" @click="$refresh(getMembersData)" class="refresh-btn">刷新</el-button>
    <div slot="content" class="wrap">
      <!-- 条件查询 -->
      <el-form class="search" :inline="true" :model="searchForm">
        <el-form-item label="会员姓名">
          <el-input v-model="searchForm.memberName" placeholder="请输入会员姓名" />
        </el-form-item>
        <el-form-item label="会员来源">
          <el-select v-model="searchForm.source" placeholder="请选择会员来源">
            <el-option v-for="item in sourceOptions" :key="item" :label="item" :value="item" />
          </el-select>
        </el-form-item>
        <el-form-item label="手机号码">
          <el-input v-model="searchForm.phone" placeholder="请输入会员手机号" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
          <el-button icon="el-icon-refresh" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
      <div>
        <!-- 会员列表 -->
        <el-table v-loading="loading" :data="memberList" :max-height="tableHeight" border>
          <el-table-column type="index" label="序号" width="50" fixed="left" />
          <el-table-column prop="memberName" label="姓名" min-width="100" fixed="left">
            <template slot-scope="scope">
              <div class="display-f align-i-c">
                <span style="font-weight: bold; margin-right: 5px;">{{ scope.row.memberName }}</span>
                <img v-if="scope.row.openId" :src="imgArr.weixin" width="16" height="16">
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="sex" label="性别">
            <template slot-scope="scope">
              {{ scope.row.sex == '0' ? '男' : (scope.row.sex == '1' ? '女' : '未知') }}
            </template>
          </el-table-column>
          <el-table-column prop="birthday" label="生日" min-width="100" />
          <el-table-column label="年龄" min-width="100">
            <template slot-scope="scope">
              {{ scope.row.age }}岁<span v-show="scope.row.age < 10 && scope.row.ageMth > 0">{{ scope.row.ageMth
                }}月</span>
            </template>
          </el-table-column>
          <el-table-column prop="phone" label="联系电话" min-width="120" />
          <el-table-column prop="source" label="来源" min-width="100" />
          <el-table-column prop="createTime" label="创建时间" min-width="160" />
          <el-table-column label="操作" width="210" fixed="right">
            <template slot-scope="scope">
              <el-button icon="el-icon-edit" type="primary" @click="editmember(scope.row)">编辑</el-button>
              <el-button icon="el-icon-view" @click="editPatient(scope.row)">查看患者</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <div class="display-f mt20 size14 color1890 pointer">
          <div @click="lastPage">上一页</div>
          <div class="ml20" @click="nextPage">下一页</div>
        </div>
      </div>
      <!-- 新增或编辑弹框 -->
      <el-dialog class="dialogEdit" :title="dialogTitle" :visible.sync="dialogVisible" width="320px"
        :before-close="done => $handleClose(done, 'editForm')" :close-on-click-modal="false">
        <el-form ref="editForm" label-width="60px" :rules="editFormRules" :model="editForm" inline>
          <el-form-item label="姓 名" prop="memberName">
            <el-input v-model="editForm.memberName" placeholder="请输入会员姓名" />
          </el-form-item>
          <el-form-item label="性 别" prop="sex">
            <el-radio-group v-model="editForm.sex">
              <el-radio :label="'0'">男</el-radio>
              <el-radio :label="'1'">女</el-radio>
              <el-radio :label="'2'">未知</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="生 日" prop="birthday">
            <el-date-picker v-model="editForm.birthday" value-format="yyyy-MM-dd" type="date" placeholder="选择患者生日"
              @blur="$computeAge(editForm.birthday, editForm)" :picker-options="pickerOptions" />
          </el-form-item>
          <el-form-item label="年 龄" class="patientAge">
            <el-form-item prop="year">
              <el-input v-model.number="editForm.year" @blur="computeBirthday">
                <template slot="append">岁</template>
              </el-input>
            </el-form-item>
            <el-form-item prop="month">
              <el-input v-model.number="editForm.month" @blur="computeBirthday">
                <template slot="append">月</template>
              </el-input>
            </el-form-item>
          </el-form-item>
          <el-form-item label="电 话" prop="phone">
            <el-input v-model="editForm.phone" :disabled="editForm.memberId" clearable placeholder="请输入联系电话" />
          </el-form-item>
          <el-form-item label="来 源" prop="source">
            <el-select v-model="editForm.source" placeholder="请选择会员来源">
              <el-option v-for="item in sourceOptions" :key="item" :label="item" :value="item" />
            </el-select>
          </el-form-item>
        </el-form>
        <!-- 操作按钮 -->
        <span slot="footer" class="dialog-footer">
          <el-button type="success" v-if="dialogTitle == '新增会员'" @click="addSave(editForm)">保存新增</el-button>
          <el-button type="success" v-if="dialogTitle == '编辑会员'" @click="editSave(editForm)">保存修改</el-button>
          <el-button @click="$cancel('dialogVisible', 'editForm')">取 消</el-button>
        </span>
      </el-dialog>
      <!-- 患者弹框 -->
      <el-dialog title="患者信息" :visible.sync="patientVisible" width="700px" :before-close="$handleClose"
        :close-on-click-modal="false">
        <el-table :data="patientForm" max-height="400" border stripe>
          <el-table-column type="index" label="序号" width="50" />
          <el-table-column prop="patientName" label="患者姓名" min-width="100" />
          <el-table-column label="年龄" min-width="100">
            <template slot-scope="scope">
              {{ scope.row.age }}岁<span v-show="scope.row.age < 10 && scope.row.ageMth > 0">{{ scope.row.ageMth
                }}月</span>
            </template>
          </el-table-column>
          <el-table-column prop="sex" label="性别" min-width="80">
            <template slot-scope="scope">{{ scope.row.sex == '0' ? '男' : (scope.row.sex == '1' ? '女' : '未知') }}</template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" min-width="160" />
        </el-table>
        <!-- 操作按钮 -->
        <span slot="footer" class="dialog-footer">
          <el-button @click="patientVisible = false">关闭</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script lang="js">
import { memberList, memberEdit, memberAdd } from "@/api/member"; // 会员请求
import { patientList } from "@/api/patient"; // 病人请求
import { validateName, validatePhone, validateYear, validateMonth } from "@/utils/regexp" // 自定义验证
import { isNull, isEmptyArray } from "@/utils/validateBase";
import { Utils } from "@/utils/utils";
import { imgArr } from "@/assets/images/img";
export default {
  data() {
    return {
      imgArr: imgArr,
      loading: true, // 加载中
      searchForm: { memberName: null, source: null, phone: null }, // 查询表单
      currentPage: 1, // 当前页
      pageSize: 10, // 显示条数
      total: 0, // 总条数
      memberList: [], // 会员列表
      dialogTitle: null, // 新增或编辑弹框标题
      dialogVisible: false, // 新增或编辑弹框状态
      patientVisible: false, // 患者弹框状态
      editForm: {}, // 新增或编辑表单
      patientForm: {}, // 患者数据
      sourceOptions: this.$sourceOptions, // 患者来源选项
      pickerOptions: { // 日期不可选范围
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      editFormRules: {
        memberName: [{ required: true, validator: validateName, trigger: 'blur' }],
        phone: [{ required: true, validator: validatePhone, trigger: 'blur' }],
        sex: [{ required: true, message: '请选择患者性别', trigger: 'change' }],
        source: [{ required: true, message: "请选择患者来源", trigger: 'change' }],
        year: [{ required: false, validator: validateYear, trigger: 'blur' }],
        month: [{ required: false, validator: validateMonth, trigger: 'blur' }],
      }, // 表单验证规则
      tableHeight: 0, // 表格最大高度
      cursorArr: [],//游标数组
      isLoadMore: true,//是否加载更多
    };
  },
  created() {
    if (document.documentElement.clientWidth > 1250) this.tableHeight = document.documentElement.clientHeight - 250;
    else this.tableHeight = document.documentElement.clientHeight - 310;
    this.cursorArr.push(null)
    this.getMembersData(); // 页面初始化获取会员列表
  },
  methods: {
    // 请求所有会员列表
    async getMembersData() {
      // if (!this.isLoadMore) return this.$message.warning('已经到最后一页了！')
      let params = { cursorIndex: this.cursorArr[this.cursorArr.length - 1], pageSize: this.pageSize, ...this.searchForm };
      let { data, code } = await memberList(params);
      if (code == 200) {
        this.cursorArr.push(isNull(data.cursorIndex) ? null : data.cursorIndex)
        this.memberList = (isNull(data.members) ? [] : data.members).map(item => ({
          ...item,
          sex: !item.sex ? '2' : item.sex
        }));
        this.isLoadMore = Utils.lt(this.memberList.length, this.pageSize) ? false : true
      }
      this.loading = false;
    },
    // 新增会员
    addMember() {
      this.dialogVisible = true;
      this.dialogTitle = "新增会员";
      this.editForm = { memberName: null, sex: "0", year: null, month: null, day: null, birthday: null, phone: null, source: null };
    },
    // 保存新增
    async addSave() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          memberAdd(this.handle()).then(res => {
            let { code } = res;
            if (code == 200) this.$message.success("新增会员成功！");
            this.refreshCurrentPage()
            this.dialogVisible = false;
            this.$refs['editForm'].resetFields();
          })
        } else return false;
      })
    },
    // 编辑会员信息
    async editmember(row) {
      row.year = (row.age || '0') * 1
      row.month = (row.ageMth || '0') * 1
      this.editForm = JSON.parse(JSON.stringify(row));
      this.dialogTitle = "编辑会员";
      this.dialogVisible = true;
    },
    // 保存会员修改
    editSave() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          memberEdit(this.handle()).then(res => {
            let { code } = res;
            if (code == 200) this.$message.success("修改会员成功！");
            this.refresh()
            this.dialogVisible = false;
            this.$refs['editForm'].resetFields();
          })
        } else return false;
      })
    },
    // 处理参数
    handle() {
      let params = JSON.parse(JSON.stringify(this.editForm));
      delete params.age;
      return params;
    },
    // 查看会员绑定的患者
    async editPatient(row) {
      let { data, code } = await patientList({ memberId: row.memberId, pageSize: 50 });
      if (code == 200) {
        this.patientForm = isNull(data.patients) ? [] : data.patients;
        this.patientVisible = true;
      }
    },
    // 计算生日
    computeBirthday() {
      this.editForm.birthday = this.$computeBirthday(this.editForm.year, this.editForm.month);
    },
    /**
    * 上一页
    */
    lastPage() {
      this.isLoadMore = true
      if (this.cursorArr.length == 2) return this.$message.warning('已经到第一页了！！')
      this.cursorArr.splice(-2)
      this.getMembersData()
    },
    /**
     * 搜索
     */
    handleSearch() {
      this.isLoadMore = true
      this.cursorArr = []
      this.cursorArr.push(null)
      this.getMembersData()
    },
    /**
     * 重置
     */
    reset() {
      this.searchForm = {
        memberName: null, source: null, phone: null
      }
      this.refresh()
    },
    /**
     * 刷新
     */
    refresh() {
      this.isLoadMore = true
      this.cursorArr = []
      this.cursorArr.push(null)
      this.getMembersData()
    },
    /**
     * 刷新当前页
     */
    refreshCurrentPage() {
      this.isLoadMore = true
      this.cursorArr.pop()
      this.getMembersData()
    },
    /**
     * 下一页
     */
    nextPage() {
      if (Utils.lt(this.memberList.length, this.pageSize)) return this.$message.warning('已经到最后一页了！')
      this.getMembersData()
    },
  },
};
</script>